/**
 * Copyright ©2022 Drivepoint
 */

import {useEffect, useMemo, useState} from "react";
import DrivepointUser from "@services/user/DrivepointUser";
import ServiceRegistry from "../services/ServiceRegistry";
import useStateChange from "./useStateChange";

export type PathContextProps = {
  companyId: string | undefined;
};

export default function usePathContext(): any {

  const params = ServiceRegistry.routeService.getCurrentPageParams();
  const user = useStateChange<DrivepointUser>("user");

  const [companyId, setCompanyId] = useState<string | undefined>();

  useEffect(() => {
    if (params[":company"]) {
      const rawCompany = params[":company"];
      const resolvedCompany = rawCompany.includes("/") ? rawCompany.split("/")[0] : rawCompany;
      ServiceRegistry.companyService.setCompanyById(resolvedCompany);
      setCompanyId(resolvedCompany);
    }
  }, [location, params]);

  useEffect(() => {
    if (!user) {
      setCompanyId(undefined);
    }
  }, [user]);

  return useMemo<PathContextProps>(() => {
    return {
      companyId: companyId
    };
  }, [companyId]);

}
